import './navigation.css'
import pic from "./logo.png";

export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='containermenu'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a href='#'>
          <img id="logo" src={pic}></img>
          </a>

        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            {/*
            <li>
              <a href='#services' className='page-scroll'>
                Servicios
              </a>
  </li>*/}

            <li>
              <a href='#portfolio' className='page-scroll'>
                Promociones
              </a>
            </li>
            <li>
              <a href='#entidades' className='page-scroll'>
                Entidades
              </a>
            </li>
            <li>
              <a href='#comercios' className='page-scroll'>
                Comercios
              </a>
            </li>
            <li>
              <a href='#institucional' className='page-scroll'>
                Intitucional
              </a>
            </li>
            <li>
              <a href='#contact' className='page-scroll'>
                Contactenos
              </a>
            </li>
            {/*<li>
              <a href='#team' className='page-scroll'>
                Team
              </a>
            </li>
            <li>
              <a href='#contact' className='page-scroll'>
                Contact
              </a>
  </li>*/}
          </ul>
        </div>
      </div>
    </nav>
  )
}
